/* your brand — theme.js
 * Shopify AJAX cart + interactive UI.
 * Re-binds on shopify:section:load so the theme editor stays interactive.
 */

const $  = (s, r=document) => r.querySelector(s);
const $$ = (s, r=document) => [...r.querySelectorAll(s)];
const isEditor = !!(window.Shopify && window.Shopify.designMode);

const moneyFormat = (window.Shopify && window.Shopify.money_format) || '${{amount}}';
function formatMoney(cents){
  const n = (cents/100);
  return moneyFormat
    .replace(/\{\{\s*amount\s*\}\}/, n.toFixed(2))
    .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(n).toString())
    .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, n.toFixed(2).replace('.', ','))
    .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(n).toString());
}

/* ---------- nav scroll state ---------- */
function initNav(){
  const nav = $('[data-nav]');
  if (!nav || nav.__navBound) return;
  nav.__navBound = true;
  const onScroll = () => nav.classList.toggle('scrolled', window.scrollY > 60);
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
}

/* ---------- side menu / cart drawer ---------- */
let overlayEl = null;
let sideMenuEl = null;
let cartEl = null;

function openSideMenu(){ sideMenuEl?.classList.add('open'); overlayEl?.classList.add('show'); sideMenuEl?.setAttribute('aria-hidden','false'); }
function closeSideMenu(){ sideMenuEl?.classList.remove('open'); overlayEl?.classList.remove('show'); sideMenuEl?.setAttribute('aria-hidden','true'); }
function openCart(){ cartEl?.classList.add('open'); overlayEl?.classList.add('show'); cartEl?.setAttribute('aria-hidden','false'); }
function closeCart(){ cartEl?.classList.remove('open'); overlayEl?.classList.remove('show'); cartEl?.setAttribute('aria-hidden','true'); }

function initDrawers(scope = document){
  overlayEl = overlayEl || $('[data-overlay]');
  sideMenuEl = sideMenuEl || $('[data-side-menu]');
  cartEl = cartEl || $('[data-cart]');

  scope.querySelectorAll('[data-menu-open]').forEach(b => {
    if (b.__bound) return; b.__bound = true;
    b.addEventListener('click', openSideMenu);
  });
  scope.querySelectorAll('[data-menu-close]').forEach(b => {
    if (b.__bound) return; b.__bound = true;
    b.addEventListener('click', closeSideMenu);
  });
  scope.querySelectorAll('[data-cart-open]').forEach(b => {
    if (b.__bound) return; b.__bound = true;
    b.addEventListener('click', openCart);
  });
  scope.querySelectorAll('[data-cart-close]').forEach(b => {
    if (b.__bound) return; b.__bound = true;
    b.addEventListener('click', closeCart);
  });

  if (overlayEl && !overlayEl.__bound){
    overlayEl.__bound = true;
    overlayEl.addEventListener('click', () => { closeSideMenu(); closeCart(); });
  }
  // Close the mobile drawer when any link inside it is tapped, so same-page
  // anchors (e.g. /#mini-grow-kit) actually scroll instead of staying hidden behind the menu.
  if (sideMenuEl && !sideMenuEl.__linksBound){
    sideMenuEl.__linksBound = true;
    sideMenuEl.addEventListener('click', e => {
      const a = e.target.closest('a[href]');
      if (!a) return;
      closeSideMenu();
      const href = a.getAttribute('href') || '';
      const hashIdx = href.indexOf('#');
      if (hashIdx === -1) return;
      const path = href.slice(0, hashIdx).replace(/\/$/, '');
      const here = location.pathname.replace(/\/$/, '');
      if (path !== '' && path !== '/' && path !== here) return;
      const target = document.getElementById(href.slice(hashIdx + 1));
      if (!target) return;
      e.preventDefault();
      setTimeout(() => target.scrollIntoView({ behavior: 'smooth', block: 'start' }), 350);
    });
  }
  if (!document.__escBound){
    document.__escBound = true;
    document.addEventListener('keydown', e => { if (e.key === 'Escape'){ closeSideMenu(); closeCart(); } });
  }
}

/* ---------- toast ---------- */
function showToast(msg){
  const toast = $('#toast');
  if (!toast) return;
  toast.textContent = msg;
  toast.classList.add('show');
  clearTimeout(showToast._t);
  showToast._t = setTimeout(() => toast.classList.remove('show'), 2200);
}

/* ---------- cart state + render ---------- */
async function fetchCart(){
  const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
  return res.json();
}

function renderCart(state){
  const cartItemsEl = $('[data-cart-items]');
  const cartTotalEl = $('[data-cart-total]');
  const cartCountEl = $('[data-cart-count]');
  if (!cartItemsEl) return;

  if (state.item_count === 0){
    cartItemsEl.innerHTML = `<p class="cart-empty">your cart is empty.</p>`;
  } else {
    cartItemsEl.innerHTML = state.items.map((item, i) => `
      <div class="cart-line" data-line-key="${item.key}" data-line-index="${i+1}">
        <div class="ph">${item.image ? `<img src="${item.image}" alt="${item.product_title}">` : ''}</div>
        <div>
          <div class="nm">${item.product_title}</div>
          <div class="sc">${(item.variant_title || '').toLowerCase()}</div>
          <div class="qty">
            <button data-line-dec aria-label="decrease">−</button>
            <span data-line-qty>${item.quantity}</span>
            <button data-line-inc aria-label="increase">+</button>
          </div>
        </div>
        <div class="pr">${item.original_line_price !== item.final_line_price
          ? `<s class="price-was">${formatMoney(item.original_line_price)}</s><span class="price-now">${formatMoney(item.final_line_price)}</span>`
          : formatMoney(item.final_line_price)}</div>
      </div>
    `).join('');
  }

  if (cartTotalEl) cartTotalEl.textContent = formatMoney(state.total_price);

  const savingEl = $('[data-cart-saving]');
  if (savingEl){
    if (state.total_discount > 0){
      let title = '';
      state.items.forEach(it => (it.line_level_discount_allocations || []).forEach(a => {
        if (!title && a.discount_application) title = a.discount_application.title;
      }));
      (state.cart_level_discount_applications || []).forEach(a => { if (!title) title = a.title; });
      const lab = savingEl.querySelector('[data-cart-saving-label]');
      const amt = savingEl.querySelector('[data-cart-saving-amount]');
      if (lab) lab.textContent = title || 'Discount';
      if (amt) amt.textContent = '\u2212' + formatMoney(state.total_discount);
      savingEl.hidden = false;
    } else {
      savingEl.hidden = true;
    }
  }
  const promoEl = $('[data-cart-promo]');
  if (promoEl){
    const need = Number(promoEl.dataset.promoQty) || 4;
    const pct = Number(promoEl.dataset.promoPct) || 60;
    const n = state.item_count || 0;
    const msg = promoEl.querySelector('[data-cart-promo-msg]');
    if (msg) msg.textContent = n >= need ? `${pct}% off unlocked` : n === 0 ? `Add ${need} items to save ${pct}%` : `Add ${need - n} more to save ${pct}%`;
    promoEl.querySelectorAll('.cart-promo-bar i').forEach((seg, i) => seg.classList.toggle('on', n >= i + 1));
    promoEl.classList.toggle('is-unlocked', n >= need);
  }
  if (cartCountEl){
    cartCountEl.textContent = state.item_count;
    cartCountEl.classList.remove('bump');
    void cartCountEl.offsetWidth;
    cartCountEl.classList.add('bump');
  }
}

async function refreshCart(){
  try {
    const state = await fetchCart();
    renderCart(state);
    return state;
  } catch (_){ /* not on a real Shopify domain */ }
}

/* ---------- add to cart ---------- */
function bindAddForms(scope = document){
  scope.querySelectorAll('[data-add-form]').forEach(form => {
    if (form.__bound) return; form.__bound = true;
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const btn = form.querySelector('[data-add]');
      const originalLabel = btn.dataset.label || btn.textContent.trim();
      btn.dataset.label = originalLabel;
      const fd = new FormData(form);
      btn.disabled = true;
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          body: fd,
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
        });
        if (!res.ok){ throw new Error('add failed'); }
        const item = await res.json();
        btn.classList.add('added');
        btn.textContent = 'added ✓';
        showToast(`${item.product_title} added to cart`);
        await refreshCart();
        setTimeout(openCart, 250);
        setTimeout(() => { btn.classList.remove('added'); btn.textContent = originalLabel; btn.disabled = false; }, 1500);
      } catch (err){
        btn.disabled = false;
        showToast('something went wrong');
      }
    });
  });
}

/* ---------- qty controls in drawer ---------- */
function bindCartLines(){
  const cartItemsEl = $('[data-cart-items]');
  if (!cartItemsEl || cartItemsEl.__bound) return;
  cartItemsEl.__bound = true;
  cartItemsEl.addEventListener('click', async e => {
    const line = e.target.closest('.cart-line');
    if (!line) return;
    const idx = Number(line.dataset.lineIndex);
    const qtyEl = line.querySelector('[data-line-qty]');
    let qty = Number(qtyEl?.textContent || 0);
    if (e.target.matches('[data-line-inc]')) qty++;
    else if (e.target.matches('[data-line-dec]')) qty = Math.max(0, qty - 1);
    else return;
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: idx, quantity: qty })
      });
      if (res.ok){
        const state = await res.json();
        renderCart(state);
      }
    } catch (_){ /* no-op */ }
  });
}

/* ---------- accordion ---------- */
function bindAccordion(scope = document){
  scope.querySelectorAll('[data-acc]').forEach(row => {
    if (row.__bound) return; row.__bound = true;
    const head = row.querySelector('.acc-head');
    head?.addEventListener('click', () => {
      const open = row.classList.toggle('open');
      head.setAttribute('aria-expanded', String(open));
    });
  });
}

/* ---------- newsletter ---------- */
function bindNewsletter(scope = document){
  const form = scope.querySelector('#nlForm');
  if (!form || form.__bound) return;
  form.__bound = true;
  form.addEventListener('submit', e => {
    const email = form.querySelector('input[type=email]')?.value.trim() || '';
    if (!/^\S+@\S+\.\S+$/.test(email)){
      e.preventDefault();
      showToast('please enter a valid email');
      return;
    }
    const success = form.querySelector('[data-nl-success]');
    if (success){ success.classList.add('show'); }
  });
}

/* ---------- reveal-on-scroll (skipped in theme editor) ---------- */
let revealIO = null;
function getRevealObserver(){
  if (revealIO) return revealIO;
  revealIO = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting){
        e.target.classList.add('in');
        revealIO.unobserve(e.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
  return revealIO;
}

function initReveal(scope = document){
  const els = scope.querySelectorAll('.reveal, .reveal-l, .reveal-r, .stagger');
  // In the theme editor, or if IntersectionObserver is unavailable, show everything.
  if (isEditor || !('IntersectionObserver' in window)){
    els.forEach(el => el.classList.add('in'));
    return;
  }
  const io = getRevealObserver();
  els.forEach(el => {
    if (el.__observed) return;
    el.__observed = true;
    io.observe(el);
  });
  // Failsafe: if anything in view is still hidden shortly after load, reveal it
  // (below-fold elements are left to the observer so the scroll effect is preserved).
  if (!window.__revealFailsafe){
    window.__revealFailsafe = true;
    window.addEventListener('load', () => {
      setTimeout(() => {
        document.querySelectorAll('.reveal:not(.in), .reveal-l:not(.in), .reveal-r:not(.in), .stagger:not(.in)').forEach(el => {
          if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add('in');
        });
      }, 1200);
    });
  }
}

/* ---------- parallax (multi-element) ---------- */
const parallaxEls = [];
let parallaxRaf = null;
function parallaxUpdate(){
  parallaxRaf = null;
  const v = window.innerHeight;
  for (const el of parallaxEls){
    const host = el.closest('[data-parallax]') || el;
    const r = host.getBoundingClientRect();
    if (r.bottom < -200 || r.top > v + 200) continue;
    const amt = Number(host.dataset.parallax) || 60;
    const p = (r.top - v) / (v + r.height);
    const t = Math.max(-amt/2, Math.min(amt/2, -p * amt));
    el.style.transform = `translate3d(0,${t.toFixed(2)}px,0) scale(1.08)`;
  }
}
function initParallax(scope = document){
  if (isEditor) return;
  // Parallax is desktop-only — on touch / small screens it causes scroll jank.
  if (window.matchMedia('(max-width: 860px)').matches || window.matchMedia('(pointer: coarse)').matches){
    scope.querySelectorAll('[data-parallax] img, img[data-parallax]').forEach(img => { img.style.transform = 'none'; });
    return;
  }
  scope.querySelectorAll('[data-parallax] img, img[data-parallax]').forEach(img => {
    if (img.__par) return; img.__par = true;
    parallaxEls.push(img);
  });
  if (!window.__parBound){
    window.__parBound = true;
    window.addEventListener('scroll', () => { if (!parallaxRaf) parallaxRaf = requestAnimationFrame(parallaxUpdate); }, { passive: true });
    window.addEventListener('resize', () => { if (!parallaxRaf) parallaxRaf = requestAnimationFrame(parallaxUpdate); }, { passive: true });
  }
  parallaxUpdate();
}

/* ---------- count-up stats ---------- */
function initCounters(scope = document){
  const els = scope.querySelectorAll('[data-count]');
  if (!els.length) return;
  if (isEditor){ els.forEach(el => { el.textContent = el.dataset.prefix || ''; el.textContent += el.dataset.count + (el.dataset.suffix || ''); }); return; }
  const io = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (!e.isIntersecting) return;
      const el = e.target; io.unobserve(el);
      const target = Number(el.dataset.count) || 0;
      const pre = el.dataset.prefix || '', suf = el.dataset.suffix || '';
      const dur = 1400; const start = performance.now();
      const tick = now => {
        const t = Math.min(1, (now - start) / dur);
        const eased = 1 - Math.pow(1 - t, 3);
        el.textContent = pre + Math.round(target * eased) + suf;
        if (t < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    });
  }, { threshold: 0.4 });
  els.forEach(el => io.observe(el));
}

/* ---------- anchors close menu ---------- */
function bindAnchors(scope = document){
  scope.querySelectorAll('a[href^="#"]').forEach(a => {
    if (a.__bound) return; a.__bound = true;
    a.addEventListener('click', () => setTimeout(closeSideMenu, 100));
  });
}

/* ---------- master init ---------- */
function initAll(scope = document){
  initNav();
  initDrawers(scope);
  bindAddForms(scope);
  bindCartLines();
  bindAccordion(scope);
  bindNewsletter(scope);
  initReveal(scope);
  initParallax(scope);
  initCounters(scope);
  bindAnchors(scope);
}

initAll();
refreshCart();

/* ---------- Shopify section editor events ---------- */
document.addEventListener('shopify:section:load', e => {
  initAll(e.target);
});
document.addEventListener('shopify:section:select', e => {
  initReveal(e.target);
});
document.addEventListener('shopify:section:reorder', () => initAll());
document.addEventListener('shopify:block:select', e => {
  initReveal(e.target.closest('section') || document);
});
